import { render, staticRenderFns } from "./apartment-heading.vue?vue&type=template&id=09db687c&scoped=true&"
import script from "./apartment-heading.ts?vue&type=script&lang=ts&"
export * from "./apartment-heading.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-heading.scss?vue&type=style&index=0&id=09db687c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db687c",
  null
  
)

export default component.exports